// extracted by mini-css-extract-plugin
module.exports = {"root":"Products_root__lgkAh","productsContainer":"Products_productsContainer__KBDYX","banner":"Products_banner__4B6n1"};